module.exports = __webpack_public_path__ + "static/media/0.cda5fc98.png";